import { BaseEitherError } from '@uniqkey-frontend/shared-app';
import {
  SupportJumpAPIIncorrectAxiosInstanceError,
  SupportJumpMissingStoreDataError,
} from '../../common/errors';

export class SupportJumpGetMobileTokensError extends BaseEitherError {}

export type TSupportJumpGetMobileTokensOperationErrors = SupportJumpGetMobileTokensError
  | SupportJumpMissingStoreDataError
  | SupportJumpAPIIncorrectAxiosInstanceError;
